module.exports = __webpack_public_path__ + "static/media/18_l_truba3_18.8_62.96.4682af4b.png";